import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function UsernameTag(prop) {
    const {text} = prop;
    const parts = text.split(/(@\w+)/g);
    return (
        <p>
        "{parts.map((part, i) =>
            part.startsWith("@") ? (
            <b><Link className='interactiveUsername tag' key={i} to={`/@${part.slice(1)}`}>
                {part}
            </Link></b>
            ) : (
            part
            )
        )}"
        </p>
    );
}
